export const PIXEL_ID = "1149394907526777";

export function fbq(...args) {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq(...args);
  }
}

export function grantPixelConsent() {
  fbq("consent", "grant");
}

export function revokePixelConsent() {
  fbq("consent", "revoke");
}

export function trackPageView() {
  fbq("track", "PageView");
}

export function trackLead({ content_name, value, currency, eventID }) {
  fbq("track", "Lead", { content_name, value, currency }, { eventID });
}

export function trackCompleteRegistration({ content_name, value, currency, eventID }) {
  fbq("track", "CompleteRegistration", { content_name, value, currency }, { eventID });
}

export function newEventId() {
  return crypto.randomUUID();
}
